import type { SiteManifestQuery } from '~/apis/sanity/queries/global';

type SiteManifestState = {
  regionTheme: SiteManifestQuery['regionTheme'] | null;
  defaultSeo: SiteManifestQuery['defaultSeo'] | null;
  appStores: SiteManifestQuery['appStores'] | null;
  social: SiteManifestQuery['social'] | null;
  slugs: SiteManifestQuery['slugs'] | null;
  fallbackImages: SiteManifestQuery['fallbackImages'] | null;
};

const createInitialState = (): SiteManifestState => ({
  regionTheme: null,
  defaultSeo: null,
  appStores: null,
  social: null,
  slugs: null,
  fallbackImages: null,
});

/**
 * Shared site-manifest chrome (SSR-safe via Nuxt useState).
 * Keeps the previous Pinia store call-site API (`fields` + `$patch`).
 */
export const useSiteManifestStore = () => {
  const state = useState<SiteManifestState>('siteManifest', createInitialState);

  return {
    get regionTheme() {
      return state.value.regionTheme;
    },
    get defaultSeo() {
      return state.value.defaultSeo;
    },
    get appStores() {
      return state.value.appStores;
    },
    get social() {
      return state.value.social;
    },
    get slugs() {
      return state.value.slugs;
    },
    get fallbackImages() {
      return state.value.fallbackImages;
    },
    $patch(data: Partial<SiteManifestQuery>) {
      state.value = {
        ...state.value,
        ...data,
      };
    },
  };
};
